export default {
    LIGHT_GREEN: '#5EB300',
    LOGIN_COLOR: '#48BB78',
    LOGOUT_COLOR: '#A0AEC0',
    LUNCH_COLOR: '#61B5FF',
    ADMINISTRATIVE_COLOR: '#003B4D',
    PRIVATE_COLOR: '#FF4D4D',
    HOLD_COLOR: '#E53E3E',
    OTHER_COLOR: '#ED64A6',
    TRAINING_COLOR: '#667EEA',
    TEAM_MEETING_COLOR: '#9F7AEA',
    BRIEF_COLOR: '#1CBBB4',
    QUEUE_LIGHT_GREEN: '#5EB300',
    QUEUE_LOGIN_COLOR: '#48BB78',
    QUEUE_LOGOUT_COLOR: '#A0AEC0',
    QUEUE_LUNCH_COLOR: '#61B5FF',
    QUEUE_ADMINISTRATIVE_COLOR: '#003B4D',
    QUEUE_PRIVATE_COLOR: '#FF4D4D',
    QUEUE_HOLD_COLOR: '#E53E3E',
    QUEUE_OTHER_COLOR: '#ED64A6',
    QUEUE_TRAINING_COLOR: '#667EEA',
    QUEUE_TEAM_MEETING_COLOR: '#9F7AEA',
    QUEUE_BRIEF_COLOR: '#1CBBB4'
}

export const colorsForPieChartCallsPerAccColorsLayout = {
    Incoming: '#49ca6d',
    Outgoing: '#61b5ff'
}

export const AreaChartColors = {
    outgoing: '#61B5FE',
    incoming: '#49CA6D',
}
export const QueueGaugeChartColors = {
    minimumRangeColor: '#55BF3B',
    middleRangeColor: '#DDDF0D',
    maximumRangeColor: '#DF5353',
    shadowColor: 'transparent',
    splitLineColor: '#999'
}
export const QueueChartColors = {
    queueCalls: '#ED64A6',
    maxWaitingTime: '#61B5FF'
}
//TODO: redesignCallTypeIcons should be defined in separate file, CallTypeColors and CallTypeIcons
// need to get all status names from server
// export const CallTypeColors = {
//     Incoming: '#10C67A',
//     Outgoing: '#4E62FF',
//     Click2Call: '#B8BDC4',
//     Default: '#B8BDC4'
// }
// export const CallTypeIcons = {
//     Incoming: 'PhoneIncoming',
//     Outgoing: 'PhoneOutgoing ',
//     Click2Call: '',
//     Default: 'Phone'
// }

export const redesignCallTypeIcons = {
    incoming: 'PhoneIncoming',
    incomingColor: '#10C67A',
    outgoing: 'PhoneOutgoing',
    outgoingColor: '#4E62FF',
    otherCalls: 'Phone',
    otherColor: '#B8BDC4'
}

export const layoutDefaultColors = {
    primary: '#3280C1',
    primary_rgba: '37, 117, 255',
    backgroundLight: '#ffffff',
    backgroundDark: '#ffffff',
    frames: '#edf2f7',
    widgetGroupBackground: '#edf2f7',
    widgetGroupFrames: '#edf2f7',
    widgetGroupTitles: '#000000',
    loginStatusLimit: '#FF3636',
    loginStatusWarning: '#FAB11E',
    inCall: '#5EB300',
    inDialing: '#478700',
    onHold: '#E53E3E',
    mainBgColor: '#FFFFFF',
    dashboardHeaderBgColor: '#FFFFFF',
    background: '#FFFFFF',
    secondaryBgColor: '#FFFFFF',
    itemsMainColor: '#ffffff',
    itemsSecondaryColor: '#f5f7fa',
    cardsBgColor: '#f5f7fa',
    mainTextColor: '#000000',
    colorWidgetHeaderText: '#899398',
    colorWidgetBackground: '#f7fafc',
    colorTableHeaderBg: '#FFFFFF',
    colorTableHeaderText: '',
    colorTableContentText: '#000000',
    colorWidgetBorder: '#BEC2C9',
    holdTimeLimitColor: '#FF0324',
    holdTimeWarningColor: '#E0C034',
    activeCallWarningColor: '#E0C034',
    activeCallLimitColor: '#FF0324'
}

export const layoutParametersColorKeys: Record<string, keyof typeof layoutDefaultColors> = {
    ColorPrimary: 'primary',
    ColorBackground: 'background',
    ColorFrames: 'frames',
    ColorWidgetGroupBackground: 'widgetGroupBackground',
    ColorWidgetGroupFrames: 'widgetGroupFrames',
    ColorWidgetGroupTitles: 'widgetGroupTitles',
    LoginStatusLimitColor: 'loginStatusLimit',
    LoginStatusWarningColor: 'loginStatusWarning',
    InCallColor: 'inCall',
    OnHoldColor: 'onHold',
    DialingColor: 'inDialing',
    MainBgColor: 'mainBgColor',
    DashboardHeaderBgColor: 'dashboardHeaderBgColor',
    SecondaryBgColor: 'secondaryBgColor',
    ItemsMainColor: 'itemsMainColor',
    ItemsSecondaryColor: 'itemsSecondaryColor',
    CardsBgColor: 'cardsBgColor',
    MainTextColor: 'mainTextColor',
    ColorWidgetHeaderText: 'colorWidgetHeaderText',
    ColorWidgetBackground: 'colorWidgetBackground',
    ColorTableHeaderBg: 'colorTableHeaderBg',
    ColorTableHeaderText: 'colorTableHeaderText',
    ColorTableContentText: 'colorTableContentText',
    WidgetBorderColor: 'colorWidgetBorder',
    HoldTimeWarningColor: 'holdTimeWarningColor',
    HoldTimeLimitColor: 'holdTimeLimitColor'
}

export const PREDEFINED_LAYOUT_COLORS: Record<string, Array<string>> = {
    ColorPrimary: [ '#2675FF', '#5EB300', '#E53E3E', '#8F57B5', '#FF674D', '#FC6BFE' ],
    MainBgColor: [ '#313544', '#3E4252', '#5F626E', '#767982', '#8C8F97', '#BABCC0' ],
    DashboardHeaderBgColor: [ '#313544', '#3E4252', '#5F626E', '#767982', '#8C8F97', '#BABCC0' ],
    SecondaryBgColor: [ '#313544', '#3E4252', '#5F626E', '#767982', '#8C8F97', '#BABCC0' ],
    ColorFrames: [ '#313544', '#3E4252', '#5F626E', '#767982', '#8C8F97', '#BABCC0' ],
    ColorBackground: [ '#313544', '#3E4252', '#5F626E', '#767982', '#8C8F97', '#BABCC0' ],
    Default: [ '#2675FF', '#5EB300', '#E53E3E', '#8F57B5', '#FF674D', '#FC6BFE' ]
}

//export const DEFAULT_LAYOUT_GENERAL_
